import React, { useState, useEffect } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { useAccesos } from '../contexts/AccesosContext';

function AddMetodos({ onNewMetodo, editingMetodo }) {
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [descripcion, setDescripcion] = useState('');
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');

    function obtenerFechaISOsinZ() {
        const fecha = new Date();
        let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
        fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
        return fechaISO;
    }

    // Convertir a una cadena en formato ISO 8601
    const fechaFormateada = obtenerFechaISOsinZ();

    useEffect(() => {
        if (editingMetodo) {
            setDescripcion(editingMetodo.descripcion);
            setIngresadoPor(editingMetodo.ingresadoPor);
            setModificacion(2);
        } else {
            setModificacion(1);
            setIngresadoPor('');
            setDescripcion('');
        }
    }, [editingMetodo]);

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const endpoint = editingMetodo ? `${server}/MgAnalisisGeneralMetodo/${editingMetodo.id}` : `${server}/MgAnalisisGeneralMetodo`;
            const method = editingMetodo ? 'PUT' : 'POST';
            
            let metodo;
            if (editingMetodo) {
                metodo = {
                    id: editingMetodo.id,
                    descripcion,
                    modificadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                    fechaIngreso: fechaFormateada,
                    modificacion
                };
            } else {
                metodo = {
                    descripcion,
                    ingresadoPor: user ? user.codigoUsuario : 'ADMIN               ',
                    fechaIngreso: fechaFormateada,
                    modificacion
                };
            }
            
            // Eliminar propiedades undefined
            Object.keys(metodo).forEach(key => metodo[key] === undefined && delete metodo[key]);

            const response = await fetch(endpoint, {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(metodo),
            });

            if (response.ok) {
                setDescripcion('');
                onNewMetodo();
                Swal.fire({
                    icon: 'success',
                    title: 'Operación exitosa',
                    showConfirmButton: false,
                    timer: 1500
                });
            } else {
                const errorData = await response.json();
                const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al guardar el método',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };

    return (
        <>
            <h2>Gestión de Métodos</h2>
            <br />
            <form id="Metodos" data-parsley-validate className="form-horizontal form-label-left" onSubmit={handleSubmit}>
                <div className="item form-group">
                    <label className="col-form-label col-md-3 col-sm-3 label-align" htmlFor="descripcion">
                        Descripción: <span className="required">*</span>
                    </label>
                    <div className="col-md-6 col-sm-8">
                        <input
                            type="text"
                            id="descripcion"
                            required="required"
                            className="form-control"
                            value={descripcion}
                            onChange={(e) => setDescripcion(e.target.value)}
                            maxLength="100"
                            placeholder="Ingrese la descripción del método"
                        />
                    </div>
                </div>

                <div className="ln_solid" />
                <div className="item form-group">
                    <div className="col-md-6 col-sm-6 offset-md-3">
                        <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Método')}>
                            {editingMetodo ? 'Actualizar' : 'Guardar'}
                        </button>
                        {editingMetodo && (
                            <button 
                                type="button" 
                                className="btn btn-secondary ms-2"
                                onClick={() => {
                                    setDescripcion('');
                                    onNewMetodo();
                                }}
                            >
                                Cancelar
                            </button>
                        )}
                    </div>
                </div>
            </form>
        </>
    );
}

export default AddMetodos;
